/*
 * Adapter for VK.com Retargeting
 */

export const channelEvents = {
  PageView: () => {
    return [[]];
  },
};



// WEBPACK FOOTER //
// ./privates/supported-channels/vkRetargeting.js